import { render, staticRenderFns } from "./QuickFilters.vue?vue&type=template&id=4ae150f4"
import script from "./QuickFilters.vue?vue&type=script&lang=js"
export * from "./QuickFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports